import { render, staticRenderFns } from "./wechatLoginCode.vue?vue&type=template&id=4007b9f4&scoped=true"
import script from "./wechatLoginCode.vue?vue&type=script&lang=js"
export * from "./wechatLoginCode.vue?vue&type=script&lang=js"
import style0 from "./wechatLoginCode.vue?vue&type=style&index=0&id=4007b9f4&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4007b9f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4007b9f4')) {
      api.createRecord('4007b9f4', component.options)
    } else {
      api.reload('4007b9f4', component.options)
    }
    module.hot.accept("./wechatLoginCode.vue?vue&type=template&id=4007b9f4&scoped=true", function () {
      api.rerender('4007b9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/temporaryLogin/wechatLoginCode/wechatLoginCode.vue"
export default component.exports